{
  "version": 1,
  "asset_id": "df4084a2-eba1-4692-9768-ac04be3418a8",
  "project_id": "1820e758-46fa-46b0-bd5a-016534d0d263",
  "url": "/__l5e/assets-v1/df4084a2-eba1-4692-9768-ac04be3418a8/deliverables-640.webp",
  "r2_key": "a/v1/1820e758-46fa-46b0-bd5a-016534d0d263/df4084a2-eba1-4692-9768-ac04be3418a8/deliverables-640.webp",
  "original_filename": "deliverables-640.webp",
  "size": 20698,
  "content_type": "image/webp",
  "created_at": "2026-07-25T02:25:51Z"
}
